import "./GetStarted.module.css";
import Header from "@/reusable_sections/Header";
import LetSTalkNumbers from "./sections/LetSTalkNumbers";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
export default function GetStartedPage() {
  return <div>
      <Header />
      <LetSTalkNumbers />
      <CommonQuestions />
      <Footer />
    </div>;
}